<template>
    <div class="newsTickerContainer colorDarkGrey fontsize16">
        <!-- <div class="newsTickerContainerTip colorWhite">
            <div class="newsTickerTip backgroundWhite rotate45"></div>
        </div> -->
        <div class="newsTickerContent padding5 backgroundWhite " :style="device === 'XS' ? '' : newstickerMeldungen.length === 0 ? 'height:fit-content' : 'height:600px;max-height: calc(100vh - 110px - 60px);' " >
            <div class="displayflex padding5 flexbetween borderBottomWidth1 borderBottomStyleSolid borderDarkGrey">
                <div class="fontsize18 fontweight600">
                    Newsticker
                </div>
                <SVGIcon name="close" class="selfAlignCenter" @click.native="$emit('close')" size="small" />
            </div>

            <div class="newsTickerMeldungenContainer" >
                <!-- {{device}} -->
                <div v-for="newstickerMeldung of newstickerMeldungen" :key="newstickerMeldung.id">
                    <!-- {{JSON.stringify(newstickerMeldung)}} -->
                    <div class="displayflex">
                        <!-- sperrung => vollsperrung || gefahr || stau -->
                        <SVGIcon :name="newstickerMeldung.message_icon" style="margin-top:20px;" />
                        <div style="width:calc(100% - 46px);margin-left:10px;">
                            <h3>{{newstickerMeldung.message_title}}</h3>
                            <p v-html="newstickerMeldung.message_description"></p>
                        </div>
                    </div>
                </div>

                <div v-if="newstickerMeldungen.length === 0" class="padding10 ">
                    Aktuell sind keine Meldungen vorhanden.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Newsticker',
  data: function () {
    return {}
  },
  methods: {},
  computed: {
    device () {
      return this.$store.state.device
    },
    newstickerMeldungen () {
      return this.$store.state.newstickerMeldungen
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.newsTickerContainer {
  bottom: calc(100% + 10px);
  right: 25%;
  position: absolute;
  z-index: 2000;
}
@media (max-width: 768px) {
  .newsTickerContainer {
    top: 48px;
    right: 0;
  }
}

.newsTickerContent {
  position: relative;
  z-index: 2;
  width: 400px;
  box-shadow: 4px 8px 14px rgba(0, 0, 0, 0.4);
}
@media (max-width: 768px) {
  .newsTickerContent {
    width: 100vw;
    height: calc(100vh - 60px);
  }
}

.newsTickerMeldungenContainer {
  overflow-y: auto;
  height: calc(100% - 40px);
}
</style>
